import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MSG_OBG_MOTIVO_DESARQUIVAMENTO_AUTOS} from '../../../../../tools/Mensagens';
import {AplicarRegraCampos} from '../../validators/aplicar-regra-campos';
import {CampoObrigatorio} from '../../validators/campo-obrigatorio';

@Component({
  selector: 'app-justificativa',
  templateUrl: './justificativa.component.html',
  styleUrls: ['./justificativa.component.css']
})
export class JustificativaComponent implements OnInit, OnDestroy {
  @Input() formulario: FormGroup;
  @Input() mostrarLabel = true;
  @Input() somenteLeitura: boolean;
  @Input() dados: string;
  justificativaCaracteresDisponiveis = 5000;

  constructor() {
  }

  ngOnInit() {
    if(!this.somenteLeitura){
      this.formulario.addControl('justificativa', new FormControl(this.dados));
    }
  }

  ngOnDestroy(): void {
    if(!this.somenteLeitura){
      this.formulario.removeControl('justificativa');
    }
  }




  public validarFormulario() {
    const campos = [
      {control: 'justificativa', mensagem: MSG_OBG_MOTIVO_DESARQUIVAMENTO_AUTOS, regra: this.validar.bind(this)}
    ];
    AplicarRegraCampos.aplicar(campos, this.formulario);
  }

  protected contarCaracteresJustificativa(caracteres: string) {
    this.justificativaCaracteresDisponiveis = 5000 - caracteres.length;
  }

  private validar(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }



}
